import React, { useState } from "react";
import { useAuth } from "../../AuthContext";
import "./Comment.css";

const CommentForm = ({ postId, onCommentSubmit }) => {
  const [comment, setComment] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [charCount, setCharCount] = useState(0);
  const { user } = useAuth();

  const MAX_CHARS = 1000;

  const handleChange = (e) => {
    const text = e.target.value;
    if (text.length <= MAX_CHARS) {
      setComment(text);
      setCharCount(text.length);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!comment.trim()) return;

    setIsSubmitting(true);
    try {
      await onCommentSubmit(comment);
      setComment("");
      setCharCount(0);
    } finally {
      setIsSubmitting(false);
    }
  };

  if (!user) {
    return (
      <div className="comment-form-login-prompt">
        <p>Please log in to leave a comment.</p>
      </div>
    );
  }

  return (
    <div className="comment-form-container">
      <form onSubmit={handleSubmit} className="comment-form">
        <div className="comment-form-header">
          <img
            src={user.profilePicture || "/images/dairls-logo-app.png"}
            alt={user.username}
            className="comment-avatar"
            onError={(e) => {
              e.target.onerror = null;
              e.target.src = "/images/dairls-logo-app.png";
            }}
          />
          <span className="comment-form-username">{user.username}</span>
        </div>
        <textarea
          value={comment}
          onChange={handleChange}
          placeholder="Share your thoughts..."
          disabled={isSubmitting}
          className="comment-textarea"
          required
        />
        <div className="comment-form-footer">
          <span
            className={`char-counter ${
              charCount > MAX_CHARS * 0.8 ? "char-counter-warning" : ""
            }`}
          >
            {charCount}/{MAX_CHARS}
          </span>
          <button
            type="submit"
            disabled={isSubmitting || !comment.trim()}
            className="comment-submit-btn"
          >
            {isSubmitting ? "Posting..." : "Post Comment"}
          </button>
        </div>
      </form>
    </div>
  );
};

export default CommentForm;
